import { render } from "./j-pagination.vue?vue&type=template&id=50269148&scoped=true"
import script from "./j-pagination.vue?vue&type=script&lang=js"
export * from "./j-pagination.vue?vue&type=script&lang=js"

import "./j-pagination.vue?vue&type=style&index=0&id=50269148&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50269148"]])

export default __exports__